// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/** Known HTTP headers. */
export enum HttpHeader {
    AccessControlAllowOrigin = 'access-control-allow-origin',
    AccessControlAllowMethods = 'access-control-allow-methods',
    AccessControlAllowHeaders = 'access-control-allow-headers',
    Authorization = 'authorization',
    CacheControl = 'cache-control',
    ContentType = 'content-type',
    ContentLength = 'content-length',
    CrossOriginResourcePolicy = 'cross-origin-resource-policy',
    Date = 'date',
    ETag = 'etag',
    Vary = 'vary',
    LastModified = 'last-modified',
    OcpApimSubscriptionKey = 'ocp-apim-subscription-key',
    OperationLocation = 'operation-location',
    OperationId = 'operation-id',
    RequestId = 'request-id',
    RequestContext = 'request-context',
    StrictTransportSecurity = 'strict-transport-security',
    TraceParent = 'traceparent',
    TraceState = 'tracestate',
    XApiKey = 'x-api-key',
    XAzureClientIP = 'x-azure-client-ip',
    XAzureFrontDoorId = 'x-azure-fdid',
    XCommit = 'x-commit',
    XContentTypeOptions = 'x-content-type-options',
    XFrontDoorHealthProbe = 'x-fd-healthprobe',
    XForwardedFor = 'x-forwarded-for',
    XMSAffinityRegion = 'x-ms-affinity-region',
    XMSClientRequestId = 'x-ms-client-request-id',
    XMSUserAgent = 'x-ms-useragent',
    XRatelimitLimit = 'x-ratelimit-limit',
    XRatelimitRemaining = 'x-ratelimit-remaining',
    XRatelimitReset = 'x-ratelimit-reset',
    XSharedLinkId = 'x-shared-link-id',
}
